import React, {useEffect, useState} from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import {Button, LinearProgress, Paper, withStyles} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbIsEntityAwaitingFirstScoreCycle,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import AlertDialog from "./PopupAlert";
import {HashLink as Link} from "react-router-hash-link";

//TODO: this is a legacy styling solution and should be updated to reflect newer MUI

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        // filter: `blur(3px)`,

    },

    parent: {
        position: "absolute",
        top:0,
        left:0,
        right:0,
        bottom:0,
        // backgroundColor: "rgba(255, 255, 255, 0.25)",
        zIndex: "2000",
        borderRadius: "8px",
        pointerEvents: "all",
    },
    child: {
        filter: `blur(5px)`,
        pointerEvents: "none",

    },
    container: {
        position: "relative",
        width: "100%",
        height: "100%",
        // margin: 0,
        // padding: 0,

    },
}));

const BorderLinearProgressDeterminate = withStyles((theme) => ({
    root: {
        height: 15,
        borderRadius: 5,
        // marginTop: -10,
        margin: 5,
    },
    dashed: {
        height: 20,
        lineHeight: 10,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 100 : 700],
    },
    bar: {
        // borderRadius: 5,
        backgroundColor: "#326a8c",
    },
    bar1Buffer: {
        // borderRadius: 5,
        backgroundColor: "#263440",
    },
}))(LinearProgress);
// const BorderLinearProgressIndeterminate = withStyles((theme) => ({
//     root: {
//         height: 10,
//         borderRadius: 5,
//         // marginTop: -10,
//     },
//     colorPrimary: {
//         backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
//     },
//     bar: {
//         borderRadius: 0,
//         backgroundColor: "#326a8c",
//     },
// }))(LinearProgress);

const SimpleBackdrop = ({
                            children,
                            // entity = null,
    isBRPView = false,
    disableForSingleEntityViewCases = false,
                        }) => {

    const classes = useStyles();
    const {customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios} = useSelector(({breachrisk}) => breachrisk);
    const authUser = useSelector(({auth}) => auth.authUser);
    const entities = portfolios
    && portfolios[customerInView]
        ? portfolios[customerInView].entities
        : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);
    // const customerStatus = customer ? customer.StatusId : null;

    const preventAccess = !disableForSingleEntityViewCases && bbIsEntityAwaitingFirstScoreCycle(myEntity);
    // console.log("Checking for access to score. preventAccess", preventAccess, "portfolios", portfolios, "entities", entities, "myEntity", myEntity, "myEntity",myEntity, "entityInView", entityInView, "loadingPortfolios", loadingPortfolios)
    const isAdmin = isCurrentUserMemberOf(authUser,"admin");

    // const open = !hasAccess && !isAdmin;
    // const dispatch = useDispatch();

    /* Timer to refresh this each minute */
    const [time, setTime] = useState(Date.now());
    useEffect(() => {
        const interval = setInterval(() => setTime(Date.now()), 1000 * 60);
        return () => {
            clearInterval(interval);
        };
    }, [portfolios, loadingPortfolios, entityInView, customerInView]);



    const loaderMax = 14
    const loaderMin = 0

    // console.log("About to determine if will show a modal for a customer not yet scored.", "customerInView", customerInView, "entityInView", entityInView, "myEntity", myEntity, "preventAccess", preventAccess, "disableForSingleEntityViewCases", disableForSingleEntityViewCases, "portfolios", portfolios, "isBRPView", isBRPView);


    if(preventAccess || (!myEntity && !loadingPortfolios[customerInView])) {
        // console.log("Score is pending so blurring.");
        if(preventAccess && isAdmin) {
            return <><AlertDialog
                title={"Heads up"}
                description={`You have access to this because you are an admin, but ${myEntity.name} does not have access to this because the first score has not yet been issued.`}
                customerId={myEntity.id}
            />
                {children}
            </>
        } else if (myEntity
            && !myEntity.lastCycle
            && !myEntity.cycle_ongoing
        ){ //a cycle hasn't even started yet. Show something generic.

            return <div className={classes.container}>


                <div className={classes.parent}>
                    <Backdrop className={classes.backdrop} open={true}>
                        <Paper className={"p-3"} style={{ textAlign: "center" }}>

                            <div className={classes.paper}>
                                <h1>Initial BreachRisk™ Results Pending</h1>
                                <h2 id="transition-modal-title">{myEntity.name}</h2>
                                <p id="transition-modal-description">The initial BreachRisk™ survey is in progress. </p>
                                <LinearProgress />
                                <br/>
                                <h3>Initial results are usually available within 96 hours.
                                </h3>
                            </div>
                        </Paper>
                    </Backdrop>
                </div>

                <div className={classes.child}>
                    {children}
                </div>
            </div>
        } else if (myEntity
            && !myEntity.lastCycle
            && myEntity.cycle_ongoing_stage
            && myEntity.cycle_ongoing_stage.id
            && myEntity.cycle_ongoing_stage.id < loaderMax //14 is the highest number of the status code
            && myEntity.cycle_ongoing_stage.id >= loaderMin //0 is the lowest status code
        ){

            const statusValue = myEntity.cycle_ongoing_stage.id;
            const statusName = myEntity.cycle_ongoing_stage.name;
            const statusDescription = myEntity.cycle_ongoing_stage.description;
            const loaderValue = Math.floor((statusValue / loaderMax) * 100);
            const loaderBuffer = Math.floor(((statusValue + 1) / loaderMax )* 100) - 5;
            const completionDateTime = myEntity.settings ? bbDangerousStringToDate(myEntity.settings.ongoing_cycle_complete_datetime) : null;

            return <div className={classes.container}>


                <div className={classes.parent}>
                    <Backdrop className={classes.backdrop} open={true}>
                        <Paper className={"p-3"} style={{ textAlign: "center" }}>

                            <div className={classes.paper}>
                                <h1>Initial BreachRisk™ Results Pending</h1>
                                <h2 id="transition-modal-title">{myEntity.name}</h2>
                                <p id="transition-modal-description">The initial BreachRisk™ survey is in progress. </p>
                                <BorderLinearProgressDeterminate variant="buffer" value={loaderValue} valueBuffer={loaderBuffer}/>
                                <h2>{`${loaderValue}% Complete`}</h2>
                                <h2>{statusName}</h2>
                                <h3><em>{statusDescription}</em></h3>


                                {completionDateTime &&
                                <h3>Estimated
                                    Completion: <strong>{bbFormattedDateString(completionDateTime, "short")}</strong>
                                </h3>
                                }

                                <br/>
                                <small>Status ID: {statusValue}</small>
                            </div>
                        </Paper>
                    </Backdrop>
                </div>

                <div className={classes.child}>
                    {children}
                </div>
            </div>
        } else if (!disableForSingleEntityViewCases &&
            myEntity
            && myEntity.settings
            // && myEntity.active_subscription
            && myEntity.ongoing_cycle_complete_datetime){

            //calculate the number of hours left.
            const now = Date.now();
            const completionDateTime = bbDangerousStringToDate(myEntity.settings.ongoing_cycle_complete_datetime);
            const nineDaysBeforeCompletion = typeof completionDateTime.getTime === 'function' ? completionDateTime.getTime() - 1000 * 60 * 60 * 24 * 9 : null;   // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
            const assumedOngoingCycleStartDate = new Date(nineDaysBeforeCompletion);
            const totalHoursExpectedToRun = Math.floor((completionDateTime - assumedOngoingCycleStartDate)/1000/60/60) + 1;
            const hoursUntilEstimatedCompletion = Math.floor((completionDateTime - now)/1000/60/60) + 1;
            // console.log("Score is pending so blurring. Expected to take a total of",totalHoursExpectedToRun, "hours. from ", bbFormattedDateString(assumedOngoingCycleStartDate), hoursUntilEstimatedCompletion, "hours remaining.");

            //now have total hours and hours remaining. This will be the last 60% of the indicator.
            const portionOfTimeRemaining = (totalHoursExpectedToRun - hoursUntilEstimatedCompletion)/totalHoursExpectedToRun;
            // console.log(portionOfTimeRemaining, "percent of time remaining");
            const portionOfProgressBarToOccupyWithInitialStatusCodes = (myEntity.active_subscription + myEntity.settings.cycle_ongoing + 1) * 5;
            const portionOfProgressBarToOccupyWithTimeRemaining = (portionOfTimeRemaining <= 1 ? portionOfTimeRemaining : 1) * 100 * 0.75; //15% for initial start, 75% for time, last 10% for fudge at the end.
            const progressBarValue = portionOfProgressBarToOccupyWithInitialStatusCodes + Math.floor(portionOfProgressBarToOccupyWithTimeRemaining);
            // console.log(progressBarValue, "percent complete. Determined by adding ", portionOfProgressBarToOccupyWithInitialStatusCodes, "with time remaining progress of", portionOfProgressBarToOccupyWithTimeRemaining);
            const contactIfHasNotFinishedSpinningDate = new Date(completionDateTime.getTime() + 1000 * 60 * 60 * 24 * 2)


            return <div className={classes.container}>

                {/*<Button variant="outlined" color="primary" onClick={handleToggle}>*/}
                {/*    Show backdrop*/}
                {/*</Button>*/}


                <div className={classes.parent}>
                    <Backdrop className={classes.backdrop} open={true}>
                        <Paper className={"p-3"} style={{ textAlign: "center" }}>

                            <div className={classes.paper}>
                                <h1>Initial BreachRisk™ Results Pending</h1>
                                <h2 id="transition-modal-title">{myEntity.name}</h2>
                                {/*<p>Added: {bbFormattedDateString(customer.CreatedDate)}</p>*/}
                                <p id="transition-modal-description">The initial BreachRisk™ survey is in progress. </p>
                                {/*<p id="transition-modal-description">This could occur if you have stumbled upon a feature under construction or if there is a misconfiguration.</p>*/}

                                {/*<p>Progress: </p>*/}

                                {/*<BorderLinearProgressIndeterminate/>*/}
                                {/*<div style={{height: 15}}>*/}
                                <BorderLinearProgressDeterminate variant="buffer" value={portionOfProgressBarToOccupyWithInitialStatusCodes} valueBuffer={progressBarValue}/>
                                <h2>{`${progressBarValue}% Complete`}</h2>

                                {/*</div>*/}

                                <h3 >Estimated Completion: <strong>{bbFormattedDateString(completionDateTime, "short")}</strong></h3>
                                <p >Please contact support@breachbits.com if you believe this is an error or if this notification persists past {bbFormattedDateString(contactIfHasNotFinishedSpinningDate, "short")}.</p>


                                <br/>
                                {/*<small>Status ID: {customer.StatusId}</small>*/}
                            </div>
                        </Paper>
                    </Backdrop>
                </div>

                <div className={classes.child}>
                    {children}
                </div>
            </div>
        } else if(isBRPView && entities && !Object.keys(entities).length > 0){
            console.warn("Appears to be no entities present, showing add loaders");
            return <div className={classes.container}>

                <div className={classes.parent}>
                    <Backdrop className={classes.backdrop} open={true}>
                        <Paper className={"p-3"} style={{ textAlign: "center" }}>

                            <div className={classes.paper}>
                                <h1>Portfolio Empty</h1>
                                {/*<h2 id="transition-modal-title">{myEntity.name}</h2>*/}
                                {/*<p>Added: {bbFormattedDateString(customer.CreatedDate)}</p>*/}
                                <p id="transition-modal-description">Your portfolio is empty. <Link smooth to={{pathname: "/board/BreachRisk/Portfolio/Manage"}}>Add a company to your portfolio</Link> to get started.</p>

                                <Button href={"/board/BreachRisk/Portfolio/Manage"}  color="primary" variant="contained">
                                    Add Companies To Your Portfolio
                                </Button>
                            </div>
                        </Paper>
                    </Backdrop>
                </div>

                <div className={classes.child}>
                    {children}
                </div>
            </div>
        } else if (myEntity
            && !myEntity.lastCycle
        ){

            console.warn("Entity found, last cycle empty, but no ongoing cycle found");

            // const statusValue = myEntity.cycle_ongoing_stage.id;
            // const statusName = myEntity.cycle_ongoing_stage.name;
            // const statusDescription = myEntity.cycle_ongoing_stage.description;
            // const loaderValue = Math.floor((statusValue / loaderMax) * 100);
            // const loaderBuffer = Math.floor(((statusValue + 1) / loaderMax )* 100) - 5;
            // const completionDateTime = myEntity.settings ? bbDangerousStringToDate(myEntity.settings.ongoing_cycle_complete_datetime) : null;

            return <div className={classes.container}>


                <div className={classes.parent}>
                    <Backdrop className={classes.backdrop} open={true}>
                        <Paper className={"p-3"} style={{ textAlign: "center" }}>

                            <div className={classes.paper}>
                                <h1>Initial BreachRisk™ Results Pending</h1>
                                <h2 id="transition-modal-title">{myEntity.name}</h2>
                                <p id="transition-modal-description">The initial BreachRisk™ survey is in progress. </p>
                                {/*<BorderLinearProgressDeterminate variant="buffer" value={loaderValue} valueBuffer={loaderBuffer}/>*/}
                                {/*<h2>{`${loaderValue}% Complete`}</h2>*/}
                                {/*<h2>{statusName}</h2>*/}
                                {/*<h3><em>{statusDescription}</em></h3>*/}


                                {/*{completionDateTime &&*/}
                                {/*<h3>Estimated*/}
                                {/*    Completion: <strong>{bbFormattedDateString(completionDateTime, "short")}</strong>*/}
                                {/*</h3>*/}
                                {/*}*/}

                                <br/>
                                {/*<small>Status ID: {statusValue}</small>*/}
                            </div>
                        </Paper>
                    </Backdrop>
                </div>

                <div className={classes.child}>
                    {children}
                </div>
            </div>
        }

        else {
            // console.warn("User does not yet have access to this entity, but missing data is unknown. Showing generic loader.");
            // return <div className={classes.container}>
            //
            //     <div className={classes.parent}>
            //         <Backdrop className={classes.backdrop} open={true}>
            //             <Paper className={"p-3"} style={{ textAlign: "center" }}>
            //
            //                 <div className={classes.paper}>
            //                     <h1>Initial BreachRisk™ Results Pending</h1>
            //                     {/*<h2 id="transition-modal-title">{myEntity.name}</h2>*/}
            //                     {/*<p>Added: {bbFormattedDateString(customer.CreatedDate)}</p>*/}
            //                     <p id="transition-modal-description">The initial BreachRisk™ survey is in progress. </p>
            //                     {/*<p id="transition-modal-description">This could occur if you have stumbled upon a feature under construction or if there is a misconfiguration.</p>*/}
            //
            //                     {/*<p>Progress: </p>*/}
            //
            //                     {/*<BorderLinearProgressIndeterminate/>*/}
            //                     {/*<div style={{height: 15}}>*/}
            //                     <BorderLinearProgressDeterminate variant="buffer" value={80} valueBuffer={95}/>
            //                     <h2>{`Nearly Complete`}</h2>
            //
            //                     {/*</div>*/}
            //
            //                     {/*<h3 >Estimated Completion: <strong>{bbFormattedDateString(completionDateTime, "short")}</strong></h3>*/}
            //                     {/*<p >Please contact support@breachbits.com if you believe this is an error or if this notification persists past {bbFormattedDateString(contactIfHasNotFinishedSpinningDate, "short")}.</p>*/}
            //
            //
            //                     <br/>
            //                     {/*<small>Status ID: {customer.StatusId}</small>*/}
            //                 </div>
            //             </Paper>
            //         </Backdrop>
            //     </div>
            //
            //     <div className={classes.child}>
            //         {children}
            //     </div>
            // </div>


                // console.log("Entity appears to not be ready with a first cycle, but missing data is unknown. Showing children without a modal.", "customerInView", customerInView, "entityInView", entityInView, "myEntity", myEntity, "preventAccess", preventAccess, "disableForSingleEntityViewCases", disableForSingleEntityViewCases, "portfolios", portfolios);
                return children

        }
    } else {
        return children;

    }
}
export default SimpleBackdrop;
